import adminConfig from "@/config/admins.json"
import AbstractAdmin from "./abstractadmin"
import {deepMerge, useConfig} from "@/plugins/obscore"

export default class AbstractAdminManager {
    admins = {}

    loadAdmins() {
        for (let adminCode in adminConfig) {
            this.useAdminRoutes(adminCode)
        }
    }

    loadAdmin(adminCode) {
        if (!adminConfig[adminCode]) {
            console.error(`Undefined Admin with code '${adminCode}'`,)
            return null
        }
        const adminDef = deepMerge(useConfig().admin, adminConfig[adminCode], false)
        adminDef.layouts = deepMerge(useConfig().layouts, adminDef.layouts, false)
        adminDef.formFields = adminConfig[adminCode].formFields
        this.admins[adminCode] = new AbstractAdmin(adminCode, adminDef)
    }

    useAdmin(adminCode) {
        if (!this.admins[adminCode])
            this.loadAdmin(adminCode)

        return this.admins[adminCode]
    }

    useAdminRoutes(adminCode) {
        if (!this.admins[adminCode])
            this.loadAdmin(adminCode)

        return this.admins[adminCode]

    }
}